"use strict";

import { FullStory, init } from "@fullstory/browser";

const FullStoryPort = {
  add: function (app, orgId) {
    if (orgId) {
      init({ orgId: orgId });
      window["_fs_run_in_iframe"] = true;

      (function (w, d, s) {
        var a = d.getElementsByTagName("head")[0];
        var r = d.createElement("script");
        r.async = 1;
        r.src = s;
        r.setAttribute("id", "usetifulScript");
        r.dataset.orgId = orgId;
        r.dataset.apiHostname = "https://guides.fullstory.com";
        a.appendChild(r);
      })(window, document, "https://guides.fullstory.com/dist/gs.js");

      app.ports.fullStoryPortBoot.subscribe(function (userIdAndUserAttrs) {
        const userId = userIdAndUserAttrs[0];
        const userAttrs = userIdAndUserAttrs[1];

        FullStory("setIdentity", {
          uid: userId,
          properties: userAttrs,
        });
      });

      app.ports.fullStoryPortStopCapturing.subscribe(function () {
        FullStory("shutdown");
      });

      app.ports.fullStoryPortLogEvent.subscribe(function (event) {
        // Copied from Amplitude.js
        const options = Object.assign(event.payload, {
          url_path: event.urlPath || location.pathname,
        });

        FullStory("trackEvent", { name: event.type, properties: options });
      });
    }
  },
};

module.exports = FullStoryPort;
